import actions from './actions'
import mutations from './mutations'
import getters from './getters'

export default {
  namespaced: true,
  state: {
    required: true,
    analytics: false,
    marketing: false,
    facebookPixel: false,
    acceptAllUrl: null,
    acceptSelectedUrl: null,
  },
  mutations: mutations,
  actions: actions,
  getters: getters
}
